import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { OPCAdminComponent } from './opc-admin.component';
import { ProductFamilyComponent } from './productfamily/productfamily.component';
import { ProductFamilyItemComponent } from './productfamily/productfamily-item/productfamily-item.component';
import { ProductLineComponent } from './productline/productline.component';
import { ProductLineItemComponent } from './productline/productline-item/productline-item-component';
import { OPCAdminModuleRouting } from './opc-admin.module.routing';
import { ManageMenuComponent } from './managemenu/managemenu.component';
import { AdminAuthGuard } from './auth-guard-service';
import { PartCategoryComponent } from './partcategory/partcategory.component';
import { PartCategoryItemComponent } from './partcategory/partcategory-item/partcategory-item.component';
import { PartGroupComponent } from './partgroup/partgroup.component';
import { PartGroupItemComponent } from './partgroup/partgroup-item/partgroup-item.component';
import { PaginationComponent } from '../shared/components/pagination/pagination.component';
import { PartComponent } from './part/part.component';
import { PartItemComponent } from './part/part-item/part-item.component';
import { ColorComponent } from "../opc-admin/color/color.component";
import {ColorItemComponent } from "../opc-admin/color/color-item.component"
import { Color } from "../opc-admin/color/color.guard"

import { NgxSpinnerModule } from 'ngx-spinner';
import {
    ConfirmDialogModule,
    ConfirmationService,
    OverlayPanelModule,
    GrowlModule,
    MultiSelectModule,
    CalendarModule,
    RadioButtonModule,
    DropdownModule
} from 'primeng/primeng';

@NgModule({
    declarations: [
        OPCAdminComponent,
        ManageMenuComponent,
        ProductFamilyComponent,
        ProductFamilyItemComponent,
        ProductLineComponent,
        ProductLineItemComponent,
        PartCategoryComponent,
        PartCategoryItemComponent,
        PartGroupComponent,
        PartGroupItemComponent,
        PartComponent,
        PartItemComponent,
        PaginationComponent,
    ColorComponent,
    ColorItemComponent
   
    ],
    imports: [
        CommonModule,
        RouterModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        OPCAdminModuleRouting,
        ConfirmDialogModule,
        OverlayPanelModule,
        GrowlModule,
        NgxSpinnerModule,
        MultiSelectModule,
        CalendarModule,
        RadioButtonModule,
        DropdownModule
    ],
    providers: [
        AdminAuthGuard,
        ConfirmationService,
        DatePipe,
        Color,
    ],
    exports: [
        OPCAdminComponent,
        ManageMenuComponent,
        PaginationComponent
    ]
})

export class OPCAdminModule {

}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/opc-admin.module.ts